<template>
  <div class="SaleStat flex-column">
    <div class="page-title flex-fixed">{{ title }}</div>
    <div class="flex-auto">
      <ATable
        ref="table"
        v-loading="loading"
        size="mini"
        class="no-pointer"
        max-height="810px"
        border
        hide-pagination
        hide-button-insert
        :data="listItems"
        :spanMethod="handleSpanMethod"
        :rowClassName="handleRowClassName"
      >
        <div slot="search">
          <div class="inline" style="width: 200px;">
            <ACustomerSelector
              size="mini"
              seller
              @select="handleSelectCustomer"
              @keydown.enter.native="handleClickSearch"
            />
          </div>
          <div class="inline" style="width: 140px;">
            <el-input placeholder="품목" v-model="product_name" />
          </div>
          <div class="inline ml-default" style="width: 110px;">
            <ACheckboxYN v-model="is_include_product">포함 수주건</ACheckboxYN>
          </div>
          <div class="inline">
            <APeriodSelector
              ref="period"
              :value="search_period"
              hide-select
              @change="handleChangePeriod"
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
              >검색(F5)</el-button
            >
          </div>
          <div class="inline ml-default" style="width: 100px;">
            <el-select size="mini" v-model="client_level_id">
              <el-option :key="0" :value="0" label="거래처등급" />
              <el-option :key="null" :value="null" label="미등록" />
              <el-option
                v-for="item in table_client_level"
                :key="item.id"
                :label="item.level"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="inline stat_type">
            <el-radio-group v-model="stat_type" size="mini">
              <el-radio-button :label="1">일자기준</el-radio-button>
              <el-radio-button :label="2">업체기준</el-radio-button>
            </el-radio-group>
          </div>
          <div class="inline" style="margin-left:10px">
            <el-button size="mini" @click="handleSelectColumn"
              >컬럼설정</el-button
            >
          </div>
          <div class="inline">
            <el-button size="mini" class="ml-default" @click="handleClickPrint"
              >인쇄</el-button
            >
          </div>
        </div>
        <el-table-column
          prop="sale_date"
          label="매출일"
          v-if="this.column_visible.sale_date"
          :width="$width.date"
        />
        <el-table-column
          prop="customer_name"
          label="거래처"
          width="100"
          v-if="this.column_visible.customer_name"
        />
        <el-table-column
          prop="contract_code"
          label="수주번호"
          width="90"
          v-if="this.column_visible.contract_code"
        />
        <el-table-column
          prop="product_name"
          v-if="this.column_visible.product_name"
          label="품목"
          width="170"
        >
          <template slot-scope="scope">
            <div class="ellipsis" :title="scope.row.product_name">
              {{ scope.row.product_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="size"
          label="Size"
          v-if="this.column_visible.size"
          :width="$width.size"
        >
          <template slot-scope="scope">
            <div class="ellipsis" :title="scope.row.size">
              {{ scope.row.size }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="수량"
          class-name="cell-number"
          v-if="this.column_visible.amount"
          :width="$width.amount"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="cost"
          label="단가"
          class-name="cell-number"
          v-if="this.column_visible.cost"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="supply_price"
          label="공급가액"
          class-name="cell-number"
          v-if="this.column_visible.supply_price"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="tax"
          label="세액"
          class-name="cell-number"
          v-if="this.column_visible.tax"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="price"
          label="합계금액"
          class-name="cell-number"
          v-if="this.column_visible.price"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="collect_price"
          label="수금액"
          class-name="cell-number"
          v-if="stat_type === 2 && this.column_visible.collect_price"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="balance"
          label="미결금"
          class-name="cell-number"
          v-if="stat_type === 2 && this.column_visible.balance"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="goods"
          label="품번"
          width="60"
          align="center"
          v-if="this.column_visible.goods"
          :formatter="resolveGoods"
        />
        <el-table-column
          prop="desc"
          label="비고"
          v-if="this.column_visible.desc"
        >
          <template slot-scope="scope">
            <div class="ellipsis" :title="scope.row.desc">
              {{ scope.row.desc }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_user_name"
          label="등록인"
          v-if="this.column_visible.created_user_name"
          :width="$width.username"
        />
      </ATable>
    </div>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="컬럼설정"
      width="50%"
      :visible.sync="dialogVisible"
      destroyOnClose
      :close-on-click-modal="false"
    >
      <ASelectColumnForm
        ref="form"
        v-if="dialogVisible"
        :data="form_data"
        @completed="handleCompleted"
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="매출현황인쇄"
      width="60%"
      :visible.sync="dialogVisible2"
      destroy-on-close
      :close-on-click-modal="false"
    >
      <SaleStatPrint
        v-if="dialogVisible2"
        :data="listItems"
        :loading="loading"
        :column="column_visible"
        :stat_type="stat_type"
        @completed="handleCompletedPrint"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { user_config } from "@/common/mixins/user_config";
import ASelectColumnForm from "../../shared/ASelectColumnForm";
import SaleStatPrint from "./SaleStatPrint";

export default {
  name: "SaleStat",
  mixins: [user_config],
  components: { ASelectColumnForm, SaleStatPrint },
  data() {
    return {
      title: this.$t("title.sale_stat"),
      search_period: { value: "0d" },
      loading_sale: false,
      loading_collect: false,
      loading_income: false,
      customer_id: 0,
      product_name: "",
      is_include_product: "N",
      stat_type: 1 /** 1=일자기준, 2=업체기준 */,
      items: [],
      collect_items: [],
      income_items: [],
      fix_column_length: 2,
      /**
       * ERP-459 매출현황 집계 구분 선택 기능
       * 'product_stat' 항목을 computed() 에서 동적으로 할당
       * 'table_product_category' 테이블 정보를 가져와서, 'stat_flag' 정보가 'Y' 인 항목만 할당
       */
      // product_stat: [
      //   { id: 1, label: '외도어', categories: [1] },
      //   { id: 2, label: '쌍도어', categories: [2] },
      //   { id: 3, label: '알루미늄', categories: [5] },
      //   { id: 4, label: '자동문', categories: [6] },
      //   { id: 5, label: '슬라이딩', categories: [7] },
      // ],
      sale_year_items: [],
      collect_year_items: [],
      dialogVisible2: false,
      dialogVisible: false,
      form_data: {},
      config_item_name: "sale_stat_column",
      column_visible: {
        sale_date: true,
        customer_name: true,
        contract_code: true,
        product_name: true,
        size: true,
        amount: true,
        cost: true,
        supply_price: true,
        tax: true,
        price: true,
        collect_price: true,
        balance: true,
        goods: true,
        desc: true,
        created_user_name: true,
      },
      column_items: [
        { key: "sale_date", value: "매출일", fixed: true },
        { key: "customer_name", value: "거래처", fixed: true },
        { key: "contract_code", value: "수주번호", fixed: false },
        { key: "product_name", value: "품목", fixed: false },
        { key: "size", value: "Size", fixed: false },
        { key: "amount", value: "수량", fixed: false },
        { key: "cost", value: "단가", fixed: false },
        { key: "supply_price", value: "공급가액", fixed: true },
        { key: "tax", value: "세액", fixed: true },
        { key: "price", value: "합계금액", fixed: true },
        { key: "collect_price", value: "수금액", fixed: true },
        { key: "balance", value: "미결금", fixed: true },
        { key: "goods", value: "품번", fixed: false },
        { key: "desc", value: "비고", fixed: false },
        { key: "created_user_name", value: "등록인", fixed: false },
      ],
      colspan_columns: [
        "contract_code",
        "product_name",
        "size",
        "amount",
        "cost",
      ],
      one_span_columns: [
        "supply_price",
        "tax",
        "price",
        "collect_price",
        "balance",
        "goods",
        "desc",
        "created_user_name",
      ],
      user_data: {},
      client_level_id: 0,
    };
  },
  mounted() {
    this.form_data.columns = this.column_items;
  },
  computed: {
    ...mapGetters([
      "userData",
      "table_customer",
      "table_product",
      "table_product_category",
      "table_client_level",
    ]),
    columns() {
      return this.$refs.table.columns;
    },
    loading() {
      return this.stat_type === 2
        ? !(!this.loading_sale && !this.loading_collect && !this.loading_income)
        : !(!this.loading_sale && !this.loading_collect);
    },
    listItems() {
      if (this.loading) {
        return [];
      }
      return this.stat_type === 2 ? this.listByCustomer : this.listByDate;
    },
    listByDate() {
      let columnName = "sale_date";
      let sumName = "일간계";
      let items = Object.assign([], this.items);
      items = this.filterByClientLevel(items);
      items.sort(this.sortByDate);
      return this.addSumRow(items, columnName, sumName);
    },
    listByCustomer() {
      let columnName = "customer_name";
      let sumName = "업체계";
      // 수입 목록에서 찾는다.
      let items = Object.assign([], this.income_items);
      items = this.filterByClientLevel(items);
      items.forEach((item) => {
        let target = null;
        item.sale_date = item.deal_date;
        if (item.sale_id) {
          target = this.items.find((sale) => sale.id === item.sale_id);
          if (target) {
            item.contract_code = target.contract_code;
            item.product_name = target.product_name;
            item.size = target.size;
            item.amount = target.amount;
            item.cost = target.cost;
            item.supply_price = target.supply_price;
            item.tax = target.tax;
            item.price = target.price;
            item.goods = target.goods;
          }
        } else if (item.collect_id) {
          target = this.collect_items.find(
            (collect) => collect.id === item.collect_id
          );
          if (target) {
            item.product_name = "수금";
            item.size = this.system.options.collect_way_flag.find(
              (f) => f.value === target.collect_way_flag
            ).label;
            item.collect_price = target.price;
          }
        }
        if (target) {
          item.customer_name = target.customer_name;
        }
      });
      // 품목 검색이 되었다면 검색되지 않는 데이터는 제거한다.
      if (this.product_name) {
        for (let i = 0; i < items.length; i++) {
          if (!items[i].product_name) {
            items.splice(i, 1);
            i--;
          }
        }
      }
      items.sort(this.sortByCustomer);
      return this.addSumRow(items, columnName, sumName);
    },
    /**
     * ERP-459 매출현황 집계 구분 선택 기능
     * 'product_stat' 항목을 computed() 에서 동적으로 할당
     * 'table_product_category' 테이블 정보를 가져와서, 'stat_flag' 정보가 'Y' 인 항목만 할당
     */
    product_stat() {
      let product_categories = JSON.parse(
        JSON.stringify(this.table_product_category)
      );
      let stat_flag_list = [];
      product_categories.forEach((item) => {
        if (item.stat_flag === "Y") {
          stat_flag_list.push({
            id: stat_flag_list.length + 1,
            label: item.name,
            categories: [item.id],
          });
        }
      });
      return stat_flag_list;
    },
  },
  methods: {
    loadData() {
      this.loading_sale = true;
      this.loading_collect = true;
      this.loading_income = true;
      this.api.listUserConfig(this.userData.id).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.user_data = res.data;
        this.form_data.selected_columns = this.getSelectedColumnData(
          this.user_data,
          this.config_item_name
        );
        let selected_columns = JSON.parse(
          JSON.stringify(this.form_data.selected_columns)
        );
        this.column_items.forEach((item) => {
          if (
            !selected_columns.find(
              (findItem) => findItem === item.key && item.fixed
            )
          ) {
            this.form_data.selected_columns.push(item.key);
          }
        });
        this.updateTableColumn(this.form_data.selected_columns);
      });
      let param = {};
      if (this.customer_id) {
        param.customer_id = this.customer_id;
      }
      if (this.product_name) {
        param.product_name = this.product_name;
      }
      if (this.is_include_product === "Y") {
        param.is_include_product = this.is_include_product;
      }
      this.api.listSaleDetail(this.period, param).then((res) => {
        if (res.error !== this.system.noError) {
          this.loading_sale = false;
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
        this.sale_year_items = res.year_data;
        this.loading_sale = false;
      });
      this.api.listCollectInome(this.customer_id, this.period).then((res) => {
        if (res.error !== this.system.noError) {
          this.loading_collect = false;
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.collect_items = res.data;
        this.collect_year_items = res.year_data;
        this.loading_collect = false;
      });
      this.api.listIncome(this.customer_id, this.period).then((res) => {
        if (res.error !== this.system.noError) {
          this.loading_income = false;
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.income_items = res.data;
        this.loading_income = false;
      });
    },
    filterByClientLevel(data) {
      let items = data;
      if (this.client_level_id === null || this.client_level_id > 0) {
        let customer_lists = this.table_customer.filter((item) => {
          if (item.client_level_id !== this.client_level_id) return false;
          return true;
        });
        items = items.filter((item) => {
          if (
            !customer_lists.find((findItem) => findItem.id === item.customer_id)
          )
            return false;
          return true;
        });
      }
      return items;
    },
    sortByDate(a, b) {
      if (a.sale_date !== b.sale_date) {
        return a.sale_date > b.sale_date ? 1 : -1;
      }
      if (a.customer_name !== b.customer_name) {
        return a.customer_name > b.customer_name ? 1 : -1;
      }
      return this.sortByDefault(a, b);
    },
    sortByCustomer(a, b) {
      if (a.customer_name !== b.customer_name) {
        return a.customer_name > b.customer_name ? 1 : -1;
      }
      if (a.sale_date !== b.sale_date) {
        return a.sale_date > b.sale_date ? 1 : -1;
      }
      return this.sortByDefault(a, b);
    },
    sortByDefault(a, b) {
      // if (a.code !== b.code) {
      //   return a.code > b.code ? 1 : -1;
      // }
      if (a.id !== b.id) {
        return a.id > b.id ? 1 : -1;
      }
      return 0;
    },
    /** 수금액 정보 행을 추가 */
    addCollectRow(items) {
      this.collect_items.forEach((c) => {
        let index = items.findIndex((i) => i.customer_id === c.customer_id);
        if (index > 0) {
          // 수금일 이후 날짜의 거래를 찾는다.
          let index2 = items.findIndex(
            (i) =>
              i.customer_id === c.customer_id &&
              ((i.sale_date === c.collect_date && i.id > c.id) ||
                i.sale_date > c.collect_date)
          );
          if (index2 > 0) {
            index = index2;
          } else {
            // 수금일 이후 일자가 없다면 수금 일자 이전 날짜 데이터의 index를 찾는다.
            let idx = index;
            let isOldDate = true;
            while (isOldDate) {
              idx++;
              if (items[index].customer_id !== items[idx].customer_id) {
                isOldDate = false;
              }
              if (
                (items[idx].sale_date === c.collect_date &&
                  items[idx].id < c.id) ||
                items[idx].sale_date > c.collect_date
              ) {
                isOldDate = false;
              }
            }
            index = idx;
          }
        }
        if (index < 0) {
          index = items.findIndex((i) => i.customer_name > c.customer_name);
        }
        if (index < 0) {
          index = items.length;
        }
        items.splice(index, 0, {
          sale_date: c.collect_date,
          customer_id: c.customer_id,
          customer_name: c.customer_name,
          product_name: "수금",
          size: this.system.options.collect_way_flag.find(
            (f) => f.value === c.collect_way_flag
          ).label,
          collect_price: c.price,
          balance: c.balance,
          desc: c.desc,
          created_user_name: c.created_user_name,
        });
      });
      return items;
    },
    /** 합계 행을 추가 */
    addSumRow(items, columnName, sumName) {
      let cur_item = "";
      let old_item = "";
      let item_supply_price = 0;
      let item_tax = 0;
      let item_price = 0;
      let item_collect_price = 0;
      let item_product_stat = {};
      let item_total_product_stat = {};
      let item_balance = "";
      let item_amount = 0;
      let total_supply_price = 0;
      let total_tax = 0;
      let total_price = 0;
      let total_collect_price = 0;
      let cur_deal_date = null;
      let cur_customer_name = null;
      let cur_code = null;
      let cur_customer_id = null;
      let old_deal_date = { value: "", index: -1 };
      let old_customer_name = { value: "", index: -1 };
      let old_code = { value: "", index: -1 };
      let old_customer_id = null;
      this.product_stat.forEach((s) => {
        item_product_stat[s.id] = 0;
      });
      this.product_stat.forEach((s) => {
        item_total_product_stat[s.id] = 0;
      });

      for (let i = 0; i < items.length; i++) {
        items[i].rowspan = [];
        cur_item = items[i][columnName];
        cur_customer_id = items[i]["customer_id"];
        cur_deal_date = items[i]["sale_date"];
        cur_customer_name = items[i]["customer_name"];
        cur_code = items[i]["code"];
        if (
          old_customer_id !== cur_customer_id ||
          old_deal_date.value !== cur_deal_date
        ) {
          old_deal_date = this.setRowSpan(
            0,
            old_deal_date,
            cur_deal_date,
            i,
            items
          );
        }
        if (
          cur_item !== old_item ||
          old_customer_id !== cur_customer_id ||
          old_customer_name.value !== cur_customer_name
        ) {
          old_customer_name = this.setRowSpan(
            1,
            old_customer_name,
            cur_customer_name,
            i,
            items
          );
        }
        if (
          cur_item !== old_item ||
          old_customer_id !== cur_customer_id ||
          old_code.value !== cur_code
        ) {
          old_code = this.setRowSpan(2, old_code, cur_code, i, items);
        }
        if (old_customer_id !== cur_customer_id) {
          old_customer_id = cur_customer_id;
        }
        //기준(일자, 업체)가 바뀌면 해당 기준에 대한 계 행을 추가한다.
        if (cur_item !== old_item) {
          if (old_item !== "") {
            let item = {
              is_sum: true,
              sale_date: sumName,
              supply_price: item_supply_price,
              tax: item_tax,
              price: item_price,
              collect_price: item_collect_price,
              balance: item_balance,
              amount: item_amount,
              rowspan: [],
            };
            // 업체계일 때는 업체명을 표시한다.
            if (this.stat_type === 2) {
              item.customer_name = old_item;
              item.contract_code = this.getProductStat(item_product_stat);
            } else {
              item.customer_name = this.getProductStat(item_product_stat);
            }
            // 계 행을 추가
            items.splice(i, 0, item);
            //  제품 통계 초기화
            for (let key in item_product_stat) {
              item_product_stat[key] = 0;
            }
            //계 행이 추가되었기 때문에 index를 +1 한다.
            old_deal_date.index++;
            old_customer_name.index++;
            old_code.index++;
            i++;
          } // if (old_item !== '')
          if (this.stat_type === 2) {
            item_balance = items[i]["balance"];
          }
          old_item = cur_item;
          item_supply_price = 0;
          item_tax = 0;
          item_price = 0;
          item_collect_price = 0;
          item_amount = 0;
        } // if (cur_item !== old_item) else
        let product_id = items[i]["product_id"];
        let product = this.table_product.find((p) => p.id === product_id);
        // 제품 통계를 업데이트
        if (product) {
          this.product_stat.forEach((s) => {
            let arCategory = this.getProductCategories(product.categories);
            if (s.categories.every((e) => arCategory.indexOf(e) > -1)) {
              item_product_stat[s.id] += items[i]["amount"];
              item_total_product_stat[s.id] += items[i]["amount"];
            }
          });
        }
        let supply_price = items[i]["supply_price"];
        if (supply_price) {
          item_supply_price += supply_price;
          total_supply_price += supply_price;
        }
        let tax = items[i]["tax"];
        if (tax) {
          item_tax += tax;
          total_tax += tax;
        }
        let price = items[i]["price"];
        if (price) {
          item_price += price;
          total_price += price;
        }
        let collect_price = items[i]["collect_price"];
        if (collect_price) {
          item_collect_price += collect_price;
          total_collect_price += collect_price;
        }
        item_balance = items[i]["balance"];
        let amount = items[i]["amount"];
        if (amount) {
          item_amount += amount;
        }
      } // for (let i = 0; i < items.length; i++)
      if (items.length < 1) {
        return items;
      }
      if (old_deal_date.index < 0) {
        old_deal_date.index = 0;
      }
      if (old_customer_name.index < 0) {
        old_customer_name.index = 0;
      }
      if (old_code.index < 0) {
        old_code.index = 0;
      }
      this.setRowSpan(0, old_deal_date, null, items.length, items);
      this.setRowSpan(1, old_customer_name, null, items.length, items);
      this.setRowSpan(2, old_code, null, items.length, items);
      // 기준별 계 행 추가
      let item = {
        is_sum: true,
        sale_date: sumName,
        supply_price: item_supply_price,
        tax: item_tax,
        price: item_price,
        collect_price: item_collect_price,
        balance: item_balance,
        amount: item_amount,
      };
      if (this.stat_type === 2) {
        item.customer_name = old_item;
        item.contract_code = this.getProductStat(item_product_stat);
      } else {
        item.customer_name = this.getProductStat(item_product_stat);
      }
      items.splice(items.length, 0, item);
      // 최종적으로 기간누계 행 추가
      items.splice(items.length, 0, {
        is_total_sum: true,
        is_sum: true,
        sale_date: "기간누계",
        supply_price: total_supply_price,
        tax: total_tax,
        price: total_price,
        collect_price: total_collect_price,
        customer_name: this.getProductStat(item_total_product_stat),
      });
      // 최종적으로 연간누계 행 추가
      items.splice(items.length, 0, {
        is_total_sum: true,
        is_sum: true,
        sale_date: "연간누계",
        supply_price: this.sale_year_items[0].year_supply_price,
        tax: this.sale_year_items[0].year_tax,
        price: this.sale_year_items[0].year_price,
        collect_price: this.collect_year_items[0].year_price,
      });
      return items;
    },
    setRowSpan(colIndex, old_value, cur_value, cur_index, items) {
      if (items.length < 1) {
        return;
      }
      if (old_value.index > -1) {
        items[old_value.index].rowspan.push({
          col: colIndex,
          span: cur_index - old_value.index,
        });
        for (let i = old_value.index + 1; i < cur_index; i++) {
          items[i].rowspan.push({ col: colIndex, span: 0 });
        }
      }
      old_value.value = cur_value;
      old_value.index = cur_index;
      return old_value;
    },
    getProductCategories(categories) {
      let ret = [];
      categories.forEach((c) => {
        ret.push(c.product_category_id);
      });
      return ret;
    },
    getProductStat(product_stat) {
      let ret = "";
      this.product_stat.forEach((s) => {
        ret += s.label + ":" + product_stat[s.id] + " ";
      });
      return ret;
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleSelectCustomer(c) {
      if (typeof c === "string") {
        this.customer_id = 0;
      } else {
        this.customer_id = c.id;
      }
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
    getSpanMethod(stat_type, column, span_count) {
      if (this.one_span_columns.find((item) => item === column.property)) {
        return { rowspan: 1, colspan: 1 };
      } else {
        let new_span_count = 0;
        let new_colspan = JSON.parse(JSON.stringify(this.colspan_columns));
        if (stat_type === 1) {
          new_colspan.push("customer_name");
        }
        new_colspan.forEach((item) => {
          if (this.column_visible[item]) {
            new_span_count++;
          }
        });
        if (new_span_count > 3) {
          return { rowspan: 1, colspan: span_count };
        } else {
          return { rowspan: 1, colspan: new_span_count };
        }
      }
    },
    handleSpanMethod({ row, column, columnIndex }) {
      if (!row.is_sum && columnIndex >= this.fix_column_length) {
        return;
      }
      if (row.is_sum) {
        switch (columnIndex) {
          case 1:
            if (this.stat_type === 2) {
              return { rowspan: 1, colspan: 1 };
            } else {
              // return { rowspan: 1, colspan: 4 };
              return this.getSpanMethod(this.stat_type, column, 4);
            }
          case 2:
            if (this.stat_type === 2) {
              // return { rowspan: 1, colspan: 3 };
              return this.getSpanMethod(this.stat_type, column, 3);
            } else {
              // return { rowspan: 0, colspan: 0 };
              if (
                this.one_span_columns.find((item) => item === column.property)
              ) {
                return { rowspan: 1, colspan: 1 };
              } else {
                return { rowspan: 0, colspan: 0 };
              }
            }
          case 3:
          case 4:
            // return { rowspan: 0, colspan: 0 };
            if (
              this.one_span_columns.find((item) => item === column.property)
            ) {
              return { rowspan: 1, colspan: 1 };
            } else {
              return { rowspan: 0, colspan: 0 };
            }
          default:
            return;
        }
      }
      let span = row.rowspan.find((r) => r.col === columnIndex);
      if (span) {
        if (span.span > 0) {
          return { rowspan: span.span, colspan: 1 };
        } else {
          return { rowspan: 0, colspan: 0 };
        }
      } else {
        return;
      }
    },
    handleRowClassName({ row }) {
      if (row.is_total_sum) {
        return "warning-row";
      }
      if (row.is_sum) {
        return "success-row";
      }
      return "";
    },
    handleSelectColumn() {
      this.form_data.fixed_columns = this.column_items.filter(
        (item) => item.fixed === true
      );
      this.dialogVisible = true;
    },
    handleCompleted(result) {
      this.dialogVisible = false;
      if (!result) {
        return;
      }
      this.setSelectedColumnData(
        this.user_data,
        this.column_items,
        result,
        this.config_item_name
      );
      this.updateTableColumn(result);
    },
    handleClickPrint() {
      this.dialogVisible2 = true;
    },
    handleCompletedPrint() {
      this.dialogVisible2 = false;
    },
    updateTableColumn(data) {
      this.column_items.forEach((item) => {
        this.column_visible[item.key] = false;
      });
      if (data.length > 0) {
        this.column_items.forEach((item) => {
          if (data.find((find_item) => find_item === item.key)) {
            this.column_visible[item.key] = true;
          }
        });
      }
    },
    resolveGoods(item) {
      return this.util.getGoodsSerialCode(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.stat_type {
  width: 160px;
  margin-left: 20px;
}
.el-table .warning-row {
  background: oldlace;
}
</style>
